import InputSong from 'Components/SongComponents/FormSongs/InputSong/InputSong'
import { Dispatch, SetStateAction } from 'react'
import FormSong from 'Components/SongComponents/FormSong'
import { Header, Title, SubTitle } from './Measurement.styles'

type MeasurementProps = {
  unitOfMeasurement: string
  setUnitOfMeasurement: Dispatch<SetStateAction<string>>
  title: string | null
  setTitle: Dispatch<SetStateAction<string | null>>
  metric: string
  formId: string
  setTargetValue: Dispatch<SetStateAction<number | null>>
  targetValue: number | null
}

const MAX_MEASURE_LENGTH = 100

const Measurement = ({
  unitOfMeasurement,
  setUnitOfMeasurement,
  title,
  setTitle,
  metric,
  formId,
  targetValue,
  setTargetValue,
}: MeasurementProps) => {
  const defaultValues: { [key: string]: string | number | null } = {
    unitOfMeasurement,
    metric,
    chartTitle: title || '',
    targetValue: targetValue || '',
  }

  return (
    <FormSong id={formId} onSubmit={() => null} defaultValues={defaultValues}>
      <Header>
        <Title>Create a chart</Title>
        <SubTitle>
          Visualize your goal progress and make analyzing information easier by
          creating a chart.
        </SubTitle>
      </Header>
      <InputSong
        autoFocus
        size={12}
        type='text'
        name='chartTitle'
        label='Give a title for this chart (Optional)'
        helperMessage={
          <span>
            For example: Enrolled Students for After School Program, Girls
            reached through Leadership Program.
          </span>
        }
        onChangeHandler={({ target }) => {
          const { value } = target as HTMLInputElement
          setTitle(value.trim())
        }}
      />
      <InputSong
        required
        autoFocus={false}
        size={12}
        type='text'
        name='unitOfMeasurement'
        placeholder='eg. Enrolled students'
        label='What are you tracking on this chart?'
        inputProps={{ maxLength: MAX_MEASURE_LENGTH }}
        helperMessage={
          <>
            <span>
              For example: Enrolled students, Donations received, Board members
              onboarded.
            </span>
            <span>{`${unitOfMeasurement.length}/${MAX_MEASURE_LENGTH}`}</span>
          </>
        }
        onChangeHandler={({ target }) => {
          const { value } = target as HTMLInputElement
          setUnitOfMeasurement(value.trim())
        }}
      />
      <InputSong
        size={12}
        type='number'
        name='targetValue'
        label='What is your goal number? (Optional)'
        onChangeHandler={({ target }) => {
          const { value } = target as HTMLInputElement
          setTargetValue(Number(value) || null)
        }}
      />
    </FormSong>
  )
}

export default Measurement
